'use strict';


export default function() {
	return {
		require: '^brgSlideGroup',
		link: postLink,
		scope: {},
	};

	function postLink(scope, element, attrs, group) {
		element.on('click', function() {
			group.back();
		});
	}
}
